
export const VisaProvider = () => {
  return (
<section
  id="visa-umroh"
  className="scroll-mt-32 py-24 bg-white"
>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">

          <div>
            <div className="text-sm uppercase tracking-[0.22em] text-accent font-semibold">
             Visa Umroh Baba Tour
            </div>

            <h2 className="font-serif-display text-primary text-4xl sm:text-5xl mt-4">
              Provider Visa Umroh Resmi MOFA Saudi Arabia untuk Travel, Group & Umroh Mandiri
            </h2>

            <div className="mt-5 inline-block bg-accent text-white px-5 py-2 rounded-full">
              Provider No. 1005145
            </div>

            <p className="text-muted mt-6 leading-relaxed">
              Baba Tour merupakan Provider Visa Umroh Resmi yang terdaftar pada
              sistem Ministry of Foreign Affairs (MOFA) Kerajaan Arab Saudi.
              Status ini merupakan keunggulan yang tidak dimiliki oleh semua
              travel umroh.
            </p>
          </div>
<div>

<div className="grid grid-cols-3 gap-3">

  <div className="border border-[#D4AF37] rounded-2xl p-3 md:p-5 text-center bg-gradient-to-b from-white to-[#faf6e8] shadow-sm">
    <div className="flex flex-col items-center gap-2">
      <div className="text-xl">⚡</div>
      <div className="text-xs md:text-base font-semibold text-[#8B6B11] leading-tight">
        Fast Response
      </div>
    </div>
  </div>

  <div className="border border-[#D4AF37] rounded-2xl p-3 md:p-5 text-center bg-gradient-to-b from-white to-[#faf6e8] shadow-sm">
    <div className="flex flex-col items-center gap-2">
      <div className="text-xl">⚡</div>
      <div className="text-xs md:text-base font-semibold text-[#8B6B11] leading-tight">
        Fast Agreement
      </div>
    </div>
  </div>

  <div className="border border-[#D4AF37] rounded-2xl p-3 md:p-5 text-center bg-gradient-to-b from-white to-[#faf6e8] shadow-sm">
    <div className="flex flex-col items-center gap-2">
      <div className="text-xl">⚡</div>
      <div className="text-xs md:text-base font-semibold text-[#8B6B11] leading-tight">
        Fast Issued
      </div>
    </div>
  </div>

</div>

  <div className="mt-8 text-center">

    <a
      href="/visa-umroh"
      className="inline-flex items-center px-8 py-4 rounded-full bg-gradient-to-r from-[#B8860B] to-[#D4AF37] text-white shadow-lg hover:scale-105 transition duration-300"
    >
      Selengkapnya
    </a>

  </div>

</div>
</div>
      </div>
    </section>
  );
};
